export default __webpack_public_path__ + "static/media/notificationSignature.4f6afc1f.wav";